'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@sprd/sprd-component-kit/v2';
import { useState } from 'react';
import { useTranslations } from 'next-intl';
import type { AmplienceLinkType } from '@/types/amplience';
import { useVolumeDiscountShipping } from '@/hooks/useVolumeDiscountShipping';
import { Link } from '@/i18n/navigation';
import { AppearanceImage } from '@/utility/appearanceConfig';
import { getOrderValue } from '@/utility/shippingCosts';
import { getCYODesignerPageHrefArgs } from '@/utility/urls';
import { ProductSliderProps } from '../ProductSlider/ProductSlider';
import { VolumeDiscountProductItem } from './VolumeDiscountProductCard';
import VolumeDiscountProductPreview from './VolumeDiscountProductPreview';
import VolumeDiscountProductSlider from './VolumeDiscountProductSlider';
import VolumeDiscountShipping from './VolumeDiscountShipping';
import VolumeDiscountSummary from './VolumeDiscountSummary';
import { getLinePrice } from './volumeDiscountPricing';
type VolumeDiscountCalculatorProps = {
  cards: VolumeDiscountProductItem[];
  seeAllProductsLink: AmplienceLinkType;
  className?: ProductSliderProps['className'];
  shopId: string;
  appearanceConfig: Record<string, AppearanceImage>;
};
export default function VolumeDiscountCalculator(t0) {
  const $ = _c(55);
  const {
    cards,
    seeAllProductsLink,
    className,
    shopId,
    appearanceConfig
  } = t0;
  const t = useTranslations("volumeDiscountCalculator");
  const [selectedIndex, setSelectedIndex] = useState(0);
  const selectedCard = cards[selectedIndex];
  let t1;
  if ($[0] !== cards) {
    t1 = cards.map(_temp);
    $[0] = cards;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [quantityPerItem, setQuantityPerItem] = useState(t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = (index, quantity) => {
      setQuantityPerItem(prev => prev.map((q, i) => i === index ? quantity : q));
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const onQuantityChange = t2;
  let printTypeIds;
  let productTypeIds;
  let summaryItems;
  let t3;
  if ($[3] !== cards || $[4] !== quantityPerItem) {
    let t4;
    if ($[9] !== quantityPerItem) {
      t4 = (card, index_0) => {
        const quantity_0 = quantityPerItem[index_0] ?? 0;
        return {
          ...card,
          index: index_0,
          quantity: quantity_0,
          ...getLinePrice(card, quantity_0)
        };
      };
      $[9] = quantityPerItem;
      $[10] = t4;
    } else {
      t4 = $[10];
    }
    summaryItems = cards.map(t4).filter(_temp2);
    productTypeIds = [...new Set(summaryItems.map(_temp3))].join(",");
    printTypeIds = [...new Set(summaryItems.flatMap(_temp4))].sort().join(",");
    t3 = getOrderValue(summaryItems.reduce(_temp5, 0), 1);
    $[3] = cards;
    $[4] = quantityPerItem;
    $[5] = printTypeIds;
    $[6] = productTypeIds;
    $[7] = summaryItems;
    $[8] = t3;
  } else {
    printTypeIds = $[5];
    productTypeIds = $[6];
    summaryItems = $[7];
    t3 = $[8];
  }
  const totalPrice = t3;
  let t4;
  if ($[11] !== quantityPerItem) {
    t4 = quantityPerItem.reduce(_temp6, 0);
    $[11] = quantityPerItem;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const totalQuantity = t4;
  let t5;
  if ($[13] !== printTypeIds || $[14] !== productTypeIds || $[15] !== shopId || $[16] !== totalPrice || $[17] !== totalQuantity) {
    t5 = {
      shopId,
      productTypeIds,
      printTypeIds,
      totalQuantity,
      totalPrice
    };
    $[13] = printTypeIds;
    $[14] = productTypeIds;
    $[15] = shopId;
    $[16] = totalPrice;
    $[17] = totalQuantity;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  const shipping = useVolumeDiscountShipping(t5);
  let t6;
  if ($[19] !== appearanceConfig || $[20] !== selectedCard || $[21] !== selectedIndex) {
    t6 = <div className="relative hidden shrink-0 items-center overflow-hidden bg-neutral-100 sm:flex sm:w-1/2 sm:justify-center sm:border-r sm:border-neutral-200"><VolumeDiscountProductPreview key={selectedIndex} selectedCard={selectedCard} appearanceConfig={appearanceConfig} /></div>;
    $[19] = appearanceConfig;
    $[20] = selectedCard;
    $[21] = selectedIndex;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  let t7;
  if ($[23] !== cards || $[24] !== className || $[25] !== quantityPerItem || $[26] !== seeAllProductsLink || $[27] !== selectedIndex) {
    t7 = <VolumeDiscountProductSlider className={className} items={cards} seeAllProductsLink={seeAllProductsLink} selectedIndex={selectedIndex} quantityPerItem={quantityPerItem} onItemSelect={setSelectedIndex} onQuantityChange={onQuantityChange} />;
    $[23] = cards;
    $[24] = className;
    $[25] = quantityPerItem;
    $[26] = seeAllProductsLink;
    $[27] = selectedIndex;
    $[28] = t7;
  } else {
    t7 = $[28];
  }
  let t8;
  if ($[29] !== shipping.amountToFreeShipping || $[30] !== shipping.isFetching || $[31] !== shipping.isOrderEmpty || $[32] !== shipping.selectShipping || $[33] !== shipping.selectedShippingTypeId || $[34] !== shipping.shippingOptions) {
    t8 = <VolumeDiscountShipping shippingData={shipping.shippingOptions} isFetching={shipping.isFetching} isOrderEmpty={shipping.isOrderEmpty} amountToFreeShipping={shipping.amountToFreeShipping} selectedShippingTypeId={shipping.selectedShippingTypeId} onShippingSelect={shipping.selectShipping} />;
    $[29] = shipping.amountToFreeShipping;
    $[30] = shipping.isFetching;
    $[31] = shipping.isOrderEmpty;
    $[32] = shipping.selectShipping;
    $[33] = shipping.selectedShippingTypeId;
    $[34] = shipping.shippingOptions;
    $[35] = t8;
  } else {
    t8 = $[35];
  }
  let t9;
  if ($[36] !== t7 || $[37] !== t8) {
    t9 = <div className="border-b border-neutral-200 bg-white pt-8 pr-0 pb-8 pl-6 text-black md:pl-9">{t7}{t8}</div>;
    $[36] = t7;
    $[37] = t8;
    $[38] = t9;
  } else {
    t9 = $[38];
  }
  let t10;
  if ($[39] !== shipping.isFetching || $[40] !== shipping.selectedShippingMethod || $[41] !== summaryItems) {
    t10 = <VolumeDiscountSummary items={summaryItems} shippingMethod={shipping.selectedShippingMethod} isFetching={shipping.isFetching} onRemove={onQuantityChange} />;
    $[39] = shipping.isFetching;
    $[40] = shipping.selectedShippingMethod;
    $[41] = summaryItems;
    $[42] = t10;
  } else {
    t10 = $[42];
  }
  let t11;
  if ($[43] !== selectedCard || $[44] !== t) {
    t11 = selectedCard && <Button variant="primary" size="l" className="mt-3 w-full sm:hidden" asChild={true}><Link href={getCYODesignerPageHrefArgs({
        productType: Number(selectedCard.productTypeId),
        appearance: Number(selectedCard.image.appearanceId),
        embroidery: selectedCard.isEmbroideryOnly ? true : undefined
      })} target="_blank">{t("cta")}</Link></Button>;
    $[43] = selectedCard;
    $[44] = t;
    $[45] = t11;
  } else {
    t11 = $[45];
  }
  let t12;
  if ($[46] !== t10 || $[47] !== t11) {
    t12 = <div className="px-6 pt-8 pb-5 sm:px-9">{t10}{t11}</div>;
    $[46] = t10;
    $[47] = t11;
    $[48] = t12;
  } else {
    t12 = $[48];
  }
  let t13;
  if ($[49] !== t12 || $[50] !== t9) {
    t13 = <div className="flex min-w-0 flex-1 flex-col">{t9}{t12}</div>;
    $[49] = t12;
    $[50] = t9;
    $[51] = t13;
  } else {
    t13 = $[51];
  }
  let t14;
  if ($[52] !== t13 || $[53] !== t6) {
    t14 = <>{t6}{t13}</>;
    $[52] = t13;
    $[53] = t6;
    $[54] = t14;
  } else {
    t14 = $[54];
  }
  return t14;
}
function _temp6(acc, curr) {
  return acc + curr;
}
function _temp5(sum, item_3) {
  return sum + item_3.discountedTotal;
}
function _temp4(item_2) {
  return item_2.printTypeIds;
}
function _temp3(item_1) {
  return item_1.productTypeId;
}
function _temp2(item_0) {
  return item_0.quantity > 0;
}
function _temp(item) {
  return item.quantity || 0;
}